var selector = {
    searchButton: '[data-search-button]',
    searchBar: '[data-search-wrapper]',
    serachResult: '[data-search-body]',
    searchInput: '[data-search-input]',
    searchForm: '[data-search-form]',
    serachRecent: '[data-recent-search-result]',
    searchClose: '[data-search-close]',
    searchRecentSuggestion: '[data-recent-suggestion]',
    clearRecentSearch: '[data-clear-recent]',
    searchTabItems: '[data-search-tab]',
    clearInputContent:'[data-clear-input]'
};
let searchForm = document.querySelectorAll(selector.searchForm);
let searchRecentSuggestion = document.querySelector(selector.searchRecentSuggestion);
let formURl = searchurl;
Array.from(searchForm).forEach(function(form) {
    formURl = form.getAttribute('action');
    form.addEventListener("submit", function(event) {
        const form = event.target;
        const formFields = form.elements;
        const searchTerm = formFields.q.value;
        if (searchTerm.replace(/\s/g, '').length > 0) {
            setRecentSearch(searchTerm);
        }
    });
});

let searchSelectors = document.querySelectorAll(selector.searchButton);
var searchBar = document.querySelector(selector.searchBar);
if (searchSelectors) {
    Array.from(searchSelectors).forEach(function(element) {
        element.addEventListener("click", (e) => {
            e.preventDefault();
            document.querySelector("body").classList.add("no-scroll");
            setTimeout(() => {
                searchBar.style.display = 'flex';
            }, 200);
            setTimeout(() => {
                searchBar.classList.add('show');
            }, 300);
            // previousFocusElement = element;
            // focusElementsRotation(searchBar);
            setTimeout(()=>{
                if(previousFocusElement == ''){
                    previousFocusElement = element;
                }
                focusElementsRotation(searchBar);
            },1000)
            if(document.querySelector(selector.searchInput)){
                setTimeout(() => {
                    document.querySelector(selector.searchInput).focus();
                },1000)
            }
            if (document.querySelector(selector.serachRecent)) {
                let querySelectorForSearch = document.querySelector(selector.serachRecent);
                if (getRecentSearch() && querySelectorForSearch) {
                    querySelectorForSearch.innerHTML = getRecentSearch();
                    clearRecentSearch();
                }
            }
            searchResult(document.querySelector(selector.searchInput).value = '');
          
        });
    })
}
let searchCloses = document.querySelectorAll(selector.searchClose);
if (searchCloses) {
    Array.from(searchCloses).forEach(function(seachClose) {
        seachClose.addEventListener("click", (e) => {
            e.preventDefault();
            if (searchBar.classList.contains('show')) {
                document.querySelector("body").classList.remove("no-scroll");
                setTimeout(() => {
                    searchBar.classList.remove('show');
                }, 500);
                setTimeout(() => {
                    searchBar.style.display = "none";
                }, 700)
                stopFocusRotation();
                previousFocusElement.focus();
                previousFocusElement = "";
            }
        });
    })
}
// search input 
var searchTyping;
if (document.querySelector(selector.searchInput)) {
    document.querySelector(selector.searchInput).addEventListener("keyup", (event) => {
        event.preventDefault();
        clearTimeout(searchTyping);
        if (searchRecentSuggestion) {
            searchRecentSuggestion.classList.add("hidden");
        }
        searchTyping = setTimeout(function() {
            let searchTerm = document.querySelector(selector.searchInput).value;
            if (searchTerm.replace(/\s/g, '').length > 0) {
                setRecentSearch(searchTerm);
            }
            searchResult(searchTerm);
        }, 500)

    });
}
if(document.querySelector(selector.clearInputContent)){
    document.querySelector(selector.clearInputContent).addEventListener("click", (event) => {
        document.querySelector(selector.searchInput).value=''
        let searchTerm = document.querySelector(selector.searchInput).value;
        searchResult(searchTerm);
    })
}
// searchResult funtion
var searchResult = function(searchTerm) {
        let resultContainer = document.querySelector(selector.serachResult);
        let recentContainer = document.querySelector(selector.serachRecent);
        if (searchTerm == '' && searchRecentSuggestion) {
            searchRecentSuggestion.classList.remove("hidden")
        }
        if (searchTerm.replace(/\s/g, '').length > 0) {
            resultContainer.innerHTML = preLoaderIcon;
            fetch(formURl + "/suggest?section_id=predictive-search&q=" + searchTerm + "&resources[type]=product,article,query,collection,page&resources[limit]=8&resources[limit_scope]=each")
                .then((response) => {
                    return response.text();
                })
                .then((result) => {
                    let searchresults = new DOMParser().parseFromString(result, 'text/html');
                    resultContainer.innerHTML = searchresults.querySelector('#shopify-section-predictive-search').innerHTML;
                    if (getRecentSearch() && resultContainer) {
                        if (recentContainer) {
                            recentContainer.innerHTML = getRecentSearch();
                        }
                        clearRecentSearch();
                        searchTabs();
                        if(animationStatus){
                            if (AOS) { 
                              AOS.refreshHard() 
                            }
                          }
                    }
                   
                })
        } else {
            resultContainer.innerHTML = '';
            if (getRecentSearch() && recentContainer) {
                recentContainer.innerHTML = getRecentSearch();
                searchTabs();
                clearRecentSearch();
                if(animationStatus){
                    if (AOS) { 
                      AOS.refreshHard() 
                    }
                  }
            }

        }
    }
    // set recent search item in the local storage
var setRecentSearch = function(sarchItem) {
    var localStorageValue = JSON.parse(localStorage.getItem("recent-search-items")) || [];
    if (localStorageValue.length > 0) {
        if (localStorageValue.indexOf(sarchItem) < 0) {
            if (localStorageValue.length >= 20) {
                localStorageValue.shift();
            }
            localStorageValue.push(sarchItem)
            localStorage.setItem("recent-search-items", JSON.stringify(localStorageValue));
        }
    } else {
        localStorageValue.push(sarchItem);
        localStorage.setItem("recent-search-items", JSON.stringify(localStorageValue));
    }
}
var clearRecentSearch = function() {
        let clearButton = document.querySelector(selector.clearRecentSearch);
        if (clearButton) {
            clearButton.addEventListener('click', function() {
                localStorage.removeItem("recent-search-items");
                document.querySelector(selector.serachRecent).innerHTML = '';
            })
        }

    }
    // get recent serach name;
var getRecentSearch = function() {
    let recentHtml = '';
    if (localStorage.getItem("recent-search-items")) {
        let localStorageValue = JSON.parse(localStorage.getItem("recent-search-items"));
        if (localStorageValue.length > 0) {
            recentHtml = '<h6 class="predictive-search-heading">'+recentHeading+' <button type="button" class="clear-search" data-clear-recent>'+clearbtnRecent+'</button></h6> <ul class="list-inline predictive-search-popular-list">'
            localStorageValue.reverse();
            Array.from(localStorageValue).forEach(function(recent, index) {
                if (recent != '') {
                    recentHtml += '<li class="predictive-search-popular-item"><a class="predictive-search-popular-link" href="'+searchurl+'?q=' + recent + '">' + recent + '</a></li>'
                }
            })
            recentHtml += '</ul>';
        }
    }

    return recentHtml;
}

function searchTabs() {
    var bindAll = function() {
        var menuElements = document.querySelectorAll(selector.searchTabItems);
        for (var i = 0; i < menuElements.length; i++) {
            menuElements[i].addEventListener('click', change, false);
            menuElements[i].addEventListener('keydown',function(e){ 
                if (e.keyCode == 13 || e.keyCode == 32) {
                  change(e);
                }
            }, false);
        }
    }

    var clear = function() {
        var menuElements = document.querySelectorAll(selector.searchTabItems);
        for (var i = 0; i < menuElements.length; i++) {
            menuElements[i].classList.remove('active');
            var id = menuElements[i].getAttribute('data-results');
            document.getElementById(id).classList.remove('active');
        }
    }

    var change = function(e) {
        clear();
        e.target.closest(selector.searchTabItems).classList.add('active');
        var id = e.currentTarget.getAttribute('data-results');
        document.getElementById(id).classList.add('active');
    }
    bindAll();
}


// var searchTab = function(){
//     let seacrhTabs = document.querySelectorAll(selector.searchTabItems);
//     Arr
// }